/** Shared K-12 grade level options */

export const GRADE_LEVELS_K12 = [
  'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12',
] as const;

export type GradeLevelK12 = (typeof GRADE_LEVELS_K12)[number];

/** ELA assessment grades include Reading and Speech tracks */
export const GRADE_LEVELS_ASSESSMENT = [
  ...GRADE_LEVELS_K12,
  'Reading',
  'Speech',
] as const;

export type GradeLevelAssessment = (typeof GRADE_LEVELS_ASSESSMENT)[number];
